var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDlpAttFlexibilityRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#FB306D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.75C18.8555 7.75 22 10.8945 22 14.75C22 18.6328 18.8555 21.75 15 21.75C11.1172 21.75 8 18.6328 8 14.75C8 10.8945 11.1172 7.75 15 7.75ZM18.0078 16.5C18.1992 16.1992 18.0898 15.7891 17.7891 15.625L15.6562 14.3945V11.0312C15.6562 10.6758 15.3555 10.375 15 10.375C14.6172 10.375 14.3438 10.6758 14.3438 11.0312V14.75C14.3438 14.9961 14.4531 15.2148 14.6719 15.3242L17.1328 16.7461C17.2148 16.8008 17.3242 16.8281 17.4609 16.8281C17.6797 16.8281 17.8984 16.7188 18.0078 16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlpAttFlexibilityRed);
export default __webpack_public_path__ + "static/media/DlpAttFlexibilityRed.9c0df48455d46adc9b6e7f021417cd67.svg";
export { ForwardRef as ReactComponent };